import * as React from 'react';
import classNames from 'classnames';
import CloseIcon from 'mdi-react/CloseIcon';
import FilterIcon from 'mdi-react/FilterIcon';

interface IState {
    open: boolean
}

interface IProps {
    distancia: boolean;
    aceptable: boolean;
    regular: boolean;
    deficiente: boolean;
    estados: boolean;
    pendientes: boolean;
    aceptados: boolean;
    rechazados: boolean;
    parciales: boolean;
    ruta: boolean;
    envio: boolean;

    toggle: (opcion: string) => void;
}

export default class Filtros extends React.PureComponent<IProps, IState> {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    private handleOpen = () => {
        this.setState({open: !this.state.open})
    };

    public render() {
        const customizerClass = classNames({
            'customizer__wrap': true,
            'customizer__wrap--open': this.state.open
        });

        return (
            <div className='customizer'>
                <button className='customizer__btn' onClick={this.handleOpen}>
                    <FilterIcon style={{fill: '#6747cd'}}/>
                </button>
                <div className={customizerClass}>
                    <div className='customizer__title-wrap'>
                        <h5>Filtros</h5>
                        <button className='customizer__close-btn' onClick={this.handleOpen}>
                            <CloseIcon/>
                        </button>
                    </div>
                    <p className='customizer__caption'/>
                    <label className='toggle-btn customizer__toggle' style={{borderBottom: '1px solid #eff1f5', display: 'table'}}>
                        <span>ESTADOS</span>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.estados} onChange={() => {this.props.toggle('estados')}}
                               readOnly={true}/>
                        <label className='toggle-btn__input-label' htmlFor='collapse_toggle'
                               style={{float: 'right'}}
                               onClick={() => {this.props.toggle('estados')}}/>

                    </label>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.pendientes} onChange={() => {this.props.toggle('pendientes')}}
                               disabled={!this.props.estados}
                               readOnly={true}/>
                        <label className='toggle-btn__input-label pendiente' htmlFor='collapse_toggle'
                               onClick={() => {
                                   if (this.props.estados) {this.props.toggle('pendientes')}
                               }}/>
                        <span>Pendientes</span>
                    </label>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.aceptados}
                               disabled={!this.props.estados}
                               readOnly={true} onChange={() => {this.props.toggle('aceptados')}}/>
                        <label className='toggle-btn__input-label aceptado' htmlFor='collapse_toggle'
                               onClick={() => {
                                   if (this.props.estados) {this.props.toggle('aceptados')}
                               }}/>
                        <span>Aceptados</span>
                    </label>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.rechazados}
                               disabled={!this.props.estados}
                               readOnly={true} onChange={() => {this.props.toggle('rechazados')}}/>
                        <label className='toggle-btn__input-label rechazado' htmlFor='collapse_toggle'
                               onClick={() => {
                                   if (this.props.estados) {this.props.toggle('rechazados')}
                               }}/>
                        <span>Rechazados</span>
                    </label>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.parciales}
                               disabled={!this.props.estados}
                               readOnly={true} onChange={() => {this.props.toggle('parciales')}}/>
                        <label className='toggle-btn__input-label parcial' htmlFor='collapse_toggle'
                               onClick={() => {
                                   if (this.props.estados) {this.props.toggle('parciales')}
                               }}/>
                        <span>Parciales</span>
                    </label>
                    <label className='toggle-btn customizer__toggle' style={{borderBottom: '1px solid #eff1f5', display: 'table'}}>
                        <span>DISTANCIA DE ENVÍO</span>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.distancia} onChange={() => {this.props.toggle('distancia')}}
                               readOnly={true}/>
                        <label className='toggle-btn__input-label' htmlFor='collapse_toggle'
                               style={{float: 'right'}}
                               onClick={() => {this.props.toggle('distancia')}}/>

                    </label>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.aceptable} onChange={() => {this.props.toggle('aceptable')}}
                               disabled={!this.props.distancia}
                               readOnly={true}/>
                        <label className='toggle-btn__input-label aceptable' htmlFor='collapse_toggle'
                               onClick={() => {
                                   if (this.props.distancia) {this.props.toggle('aceptable')}
                               }}/>
                        <span>{'< 50m - Aceptable'}</span>
                    </label>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               disabled={!this.props.distancia}
                               checked={this.props.regular} readOnly={true} onChange={() => {this.props.toggle('regular')}}/>
                        <label className='toggle-btn__input-label regular' htmlFor='collapse_toggle'
                               onClick={() => {
                                   if (this.props.distancia) {this.props.toggle('regular')}
                               }}/>
                        <span>{'< 100m - Regular'}</span>
                    </label>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.deficiente} readOnly={true}
                               disabled={!this.props.distancia} onChange={() => {this.props.toggle('deficiente')}}/>
                        <label className='toggle-btn__input-label deficiente' htmlFor='collapse_toggle'
                               onClick={() => {
                                   if (this.props.distancia) {this.props.toggle('deficiente')}
                               }}/>
                        <span>{'> 100m - Deficiente'}</span>
                    </label>
                    <p style={{borderBottom: '1px solid #eff1f5'}}>RUTA</p>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.ruta} readOnly={true} onChange={() => {this.props.toggle('ruta')}}/>
                        <label className='toggle-btn__input-label ruta' htmlFor='collapse_toggle'
                               onClick={() => {this.props.toggle('ruta')}}/>
                        <span>Ruta</span>
                    </label>
                    <p style={{borderBottom: '1px solid #eff1f5'}}>COORD. DE ENVÍO</p>
                    <label className='toggle-btn customizer__toggle'>
                        <input className='toggle-btn__input' type='checkbox' name='collapse_toggle'
                               checked={this.props.envio} readOnly={true} onChange={() => {this.props.toggle('envio')}}/>
                        <label className='toggle-btn__input-label' htmlFor='collapse_toggle'
                               onClick={() => {this.props.toggle('envio')}}/>
                        <span>Mostrar envíos</span>
                    </label>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/mapa/filtros.tsx